import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

interface BadgeDetailSheetProps {
  badge: {
    type: string;
    name: string;
    description: string;
    imageAsset: string;
    points: number;
    earned: boolean;
    awardedAt: number | null;
  } | null;
  onClose: () => void;
}

export function BadgeDetailSheet({ badge, onClose }: BadgeDetailSheetProps) {
  if (!badge) return null;

  return (
    <Sheet open={!!badge} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="bottom" className="rounded-t-2xl pb-8">
        <SheetHeader className="items-center text-center pt-2">
          <div className="relative mb-2">
            <img
              src={`/badges/${badge.imageAsset}`}
              alt={badge.name}
              className={cn(
                "w-32 h-32 object-contain mx-auto",
                !badge.earned && "grayscale opacity-50"
              )}
            />
            {badge.earned && (
              <div className="absolute -top-1 -right-1 bg-amber-400 rounded-full w-8 h-8 flex items-center justify-center text-base shadow">
                ⭐
              </div>
            )}
          </div>
          <SheetTitle className="text-xl">{badge.name}</SheetTitle>
        </SheetHeader>

        <div className="mt-4 text-center space-y-3 px-2">
          <p className="text-gray-600">{badge.description}</p>

          {badge.earned && badge.awardedAt ? (
            <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm font-medium px-4 py-2 rounded-full">
              <span>🏆</span>
              <span>
                Awarded{" "}
                {new Date(badge.awardedAt).toLocaleDateString("en-AU", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </div>
          ) : (
            <div className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 text-gray-500 text-sm font-medium px-4 py-2 rounded-full">
              <span>🔒</span>
              <span>Keep playing to unlock this!</span>
            </div>
          )}

          <p className="text-sm text-amber-600 font-semibold">
            Worth {badge.points} pts
          </p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
